import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { CupService } from '../shared/services/cup.service';
import { UrlconstantsService } from '../shared/services/urlconstants.service';
import { PcpScorecardService } from '../providerportal/pcp-scorecard/pcp-scorecard.service';
import { EpahafService } from '../providerportal/epahaf/epahaf.service';
import { SecureStorageService } from '../secure-storage.service';
import { saveAs } from "file-saver";
import { Modal } from 'bootstrap';
import moment from 'moment-timezone';
@Component({
    selector: 'app-care-plan-document',
    templateUrl: './care-plan-document.component.html',
    styleUrls: ['./care-plan-document.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CarePlanDocumentComponent implements OnInit {

  selectedSite: any;
  sites: any[];
  public urlConstant: any = this.urlconstantsService.fetchUrl();
  showSpinner = false;
  showView: boolean;
  providers: any[] = [];
  showProviders = false;
  diseasesList: Array<any> = [];
  selectedProviderModel: any;
  pcpDropdownforDCE: boolean = false;
  public showCollapseAll: boolean = false;
  public sitePlaceHolder: string;
  measureList: Array<any> = [];
  medicalMeasureList: Array<any> = [];
  public providerAffiliationList: any[];
  pcpChanged: boolean;
  selectedProvider: any;
  loadProviderAffiliationSubscription: any;
  data = [];
  pcpscorecard: boolean = false;
  pcpdetails = [];
  diseasesList51: Array<any> = [];
  diseasesList52: Array<any> = [];
  diseasesList53: Array<any> = [];
  diseasesList57: Array<any> = [];
  diseasesList58: Array<any> = [];
  showNoRecords: boolean;
  pdfPcpId: any;

  finalMeasureList: Array<any> = [];
  public qmDataGrpByMember = {};
  memlength = [];

  opmrData = [];
  uniqueMonth = [];
  dropdownYear = [];
  omprFinalData = [];
  rows = [];
  headrows = [];
  latestdate;

  selectedMembers = [];
  isShowOverView = true;
  selectedFiles = [];
  selectedMemberDetails:any;
  handleResults(searchObj) {
    this.data = searchObj;
  }

  constructor(
    private secureStorage:SecureStorageService,
    private cupService: CupService,
    private urlconstantsService: UrlconstantsService,
    private pcpscorecardService: PcpScorecardService,
    private epahafService: EpahafService
  ) { }

  ngOnInit() {
    this.getExternalDashboard();
    this.getPCPProviders();
    // console.log(this.getCurrentDateInRequiredFormat());
  }

  head = [['Category', 'PCP', 'Neighborhood', 'Region']]
  newhead = [
    [
      { content: 'People', colSpan: 3, styles: { fillColor: '#000000' } },
      { content: 'Data', colSpan: 2, styles: { fillColor: '#000000' } }
    ],
    ['CategoryNew', 'PCP', 'Neighborhood', 'Region', 'Benchmark']
  ];



  getExternalDashboard() {
    this.sites = [];
    this.pcpscorecard = false;
    const username = this.cupService.getUserNameFromJWT();
    const url = this.urlConstant.providerDashboard ;
    this.showSpinner = true;
    this.cupService.retrieveData('post', url).subscribe(
      data => {
        if (data != null) {
          // this.sites = data.sites;
          if (data.sites && data.sites.length) {
            data.sites.map(element => {
              this.sites.push({
                'id': element.siteUid,
                'value': element.siteName,
                'label': element.siteName
              })
            });
          }
          this.showView = true;
        }
        this.showSpinner = false;
      },
      error => {
        this.showSpinner = false;
      }
    );
  }

  pcpAllSites = [];
  getPCPProviders() {
    this.providers = [];
    //this.activatedMenu = this.items[0];
    this.showProviders = false;
    const siteDetailURL = this.urlConstant.userSiteProviders
    setTimeout(() => {
      this.showSpinner = true;
    }, 100);
    let checkDuplicates = [];
    this.cupService.retrieveData('post', siteDetailURL).subscribe(
      siteData => {
        if (siteData && siteData.length) {
          //console.log("getPCPProviders :",siteData);
          siteData.map(each => {
            if (each.providers && each.providers.length > 0) {
              let providerIds = [];
              each.providers.map(element => {
                if (element.pcp && element.region.indexOf("OBSOLETE") === -1) {
                  element.value =
                    element.name +
                    "\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0" +
                    element.region +
                    "\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0" + element.address.substring(0, 14);
                  element.providerUid = element.id;
                  element.id = element.providerId;
                  if (!checkDuplicates.includes(element.value)) {
                    checkDuplicates.push(element.value);
                    this.providers.push(element);
                  }
                  if (!providerIds.includes(element.providerId)) {
                    providerIds.push(element.providerId);
                  }
                }
              });
              this.pcpAllSites.push({
                value: { id: each.siteUid, value: each.name },
                uid: providerIds
              });
            }
          });
        } else {
          this.diseasesList = [];
        }
        this.showProviders = true;
        this.showSpinner = false;

      },
      error => {
        this.showSpinner = false;
      }
    );
  }

  setProviders(e) {
    this.selectedSite = e;
    if (e.value === "DCE-CMMI Providers") {
      this.pcpDropdownforDCE = true;
      this.openModal('CMMIDCEMessageModal');
    }
    this.showCollapseAll = false;
    this.sitePlaceHolder = '';
    this.providers = [];
    this.diseasesList = [];
    this.measureList = [];
    this.medicalMeasureList = [];
    this.providerAffiliationList = [];
    //this.unsubscribeAll();
    this.setExternalProviders();
    this.pcpChanged = true;
    //this.providerAffiliationList = [];
  }

  setExternalProviders() {
    this.providers = [];
    //this.activatedMenu = this.items[0];
    this.showProviders = false;
    const siteDetailURL = this.urlConstant.userSiteGet.replace(
      '{siteUid}',
      this.selectedSite.id
    );
    this.showSpinner = true;
    let checkDuplicates = [];
    this.cupService.retrieveData('get', siteDetailURL).subscribe(
      siteData => {
        if (siteData) {
          //console.log("siteData :",siteData)
          //if (siteData.siteProviderConfig && !(_.isEmpty(siteData.siteProviderConfig))) {
          if (siteData.siteProviderConfig && siteData.siteProviderConfig != null) {
            //  this.providers = siteData.siteProviderConfig;
            siteData.siteProviderConfig.map(element => {
              if (element.neighborhood && element.pcp && element.region.indexOf("OBSOLETE") === -1) {
                element.value =
                  element.name +
                  "\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0" +
                  element.region +
                  "\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0" + element.address.substring(0, 14);
                element.providerUid = element.id;
                element.id = element.providerId;
                if (!checkDuplicates.includes(element.value)) {
                  checkDuplicates.push(element.value);
                  this.providers.push(element);
                }
              }
            });
            // this.selectedProvider = this.providers[0];
            // this.onProvidersSubmit(this.selectedProvider);
          } else {
            this.diseasesList = [];
          }
        }
        this.showProviders = true;
        this.showSpinner = false;
      },
      error => {
        this.showSpinner = false;
      }
    );
  }

  private getProviderInfoByValue(providerUid) {

    if (this.providers && this.providers.length > 0) {
      return this.providers.find(x => x.value == providerUid);
    }
  }

  public onProvidersSubmit(selectedProvider) {
    this.showCollapseAll = false;
    this.diseasesList = [];
    this.measureList = [];
    this.medicalMeasureList = [];
    this.pcpdetails = [];
    this.pdfPcpId = '';
    this.selectedMembers = [];
    if (selectedProvider != undefined) {
      if (!this.pcpChanged) {
        //const pcp = _.find(this.pcpAllSites, (each => {
        const pcp: any = this.pcpAllSites.find((each => {
          if (each.uid.includes(selectedProvider.id)) {
            return each;
          }
        }));
        if (pcp) {
          this.selectedSite = pcp.value
        }
        else {
          this.selectedSite = undefined;
        }
      }
      let provider = this.getProviderInfoByValue(selectedProvider.value);
      this.selectedProvider = provider;
      this.getMemberDetails(provider.id)
      // this.epahafService.getListOfFileNetDocuments([{'key':'MemberID',value:'000M97303'},{key:'documentType',value:'Care_Plan'},{'key':'MemberID',value:'226Y06942'},{key:'documentType',value:'Care_Plan'}],'CASPER_MEMBER_DOC','PP').subscribe((data)=>{
      //   console.log(data);
      // })
      //console.log("Printing pcpdetails :",this.pcpdetails)

    }
  }
  async downloadSingleFile(docId,readDate){
    this.showSpinner = true;
    let responseData = await this.downloadFileswithId(docId);
    this.showSpinner = false;
    if (responseData) {

      const blob = this.binary64ToBlob(responseData.docContent, responseData.fileType, 512);
      saveAs(blob, responseData.filename);
      let username = this.cupService.getUserNameFromJWT();
      if( readDate.length<=0) {
        this.epahafService.readReceiptForCareplan(blob, [{ 'key': 'ReadReceipt', value: 'true' }, { 'key': 'ProviderAccessedDate', value: this.getCurrentDateInRequiredFormat()}, { 'key': 'PPUserName', value: username }, { 'key': 'PPUserID', value: username }, { 'key': 'PCPID', value: this.selectedProvider.id }], 'CASPER_MEMBER_DOC', 'PP',docId).subscribe(res => {
          //console.log(res);
          this.downloadCarePlanDoc(this.selectedMemberDetails)
        })
    }
    } 
  }
  getCurrentDateInRequiredFormat(){
    // let moment = require('moment-timezone');
        let zone = moment.tz.guess(true);
        moment.tz.setDefault(zone);
        let tmp = moment.tz("America/Los_Angeles").format('MM/DD/YYYY HH:mm:ss');
        return tmp;
  }
  async downloadCarePlanDoc(memberDetails) {
    this.selectedMemberDetails = memberDetails;
    let memberId = memberDetails.memberHmoID; 
    this.showSpinner = true;
    this.epahafService.getListOfDocXDocuments([{ 'key': 'MemberID', value: memberId }, { key: 'DocumentType', value: 'Casper Case Management Doc' }]).subscribe(async (data: any) => {
      if (data && data.errCode == null && data.keyValuePairListWrapperlist.length > 0) {
        this.selectedFiles = []
        for (let singleKvp of data.keyValuePairListWrapperlist) {
          let fileInfo = {docId:'',filename:'',createdDate:'',readDate:'',docName:'',faxStatus:''}
          if (singleKvp && singleKvp.keyvaluePairWr && singleKvp.keyvaluePairWr.length > 0) {
           

            for (let kvpData of singleKvp.keyvaluePairWr) {
              if (kvpData && kvpData.key && kvpData.key == "DocumentId") {
                fileInfo.docId = kvpData.value
              }
              if (kvpData && kvpData.key && kvpData.key == "DocumentTitle") {
                fileInfo.filename = kvpData.value
              }
              if (kvpData && kvpData.key && kvpData.key == "CreatedDate") {
                fileInfo.createdDate = kvpData.value
              }
              if (kvpData && kvpData.key && kvpData.key == "DocName") {
                fileInfo.docName = kvpData.value
              }
              if (kvpData && kvpData.key && kvpData.key == "faxStatus") {
                fileInfo.faxStatus = kvpData.value
              }
              if (kvpData && kvpData.key && kvpData.key == "ProviderAccessedDate") {
                fileInfo.readDate = kvpData.value == '' ? '' :moment.utc(kvpData.value).tz('America/Los_Angeles').format('YYYY-MM-DD HH:mm:ss')

              }
              
            }
            if(fileInfo.docName ==='Care_Plan_PCP'){
              this.selectedFiles.push(fileInfo)

            }
            if(fileInfo.docName ==='Care Plan'){
              if(["ready","inprogress","failed","delivered"].includes(fileInfo.faxStatus)){
                this.selectedFiles.push(fileInfo)

              }
            }
            
          }

        }
        this.showSpinner = false;
        this.isShowOverView = false;
      } else {
        this.selectedFiles = []
        this.showSpinner = false;
        this.openModal('noCarePlan');
      }
    }, _ => {
      this.showSpinner = false;
    })
  }
  openModal(modalId){
    const modalID=document.getElementById(modalId);
    const modal=new Modal(modalID);
    modal.show();
  }
  binary64ToBlob(binary64String, contentType, sliceSize) {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;

    const byteCharacters = atob(binary64String);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  downloadFileswithId(id) {
    // return this.epahafService.getDownloadDocxDocument(id, 'CASPER_MEMBER_DOC').toPromise()
    return this.epahafService.getDownloadDocxDocument(id).toPromise();
  }
  getMemberDetails(providerId) {
    this.showSpinner = true;
    let name = this.cupService.getUserNameFromJWT();
    this.epahafService.getEligibilityDetails(name).subscribe(
      (response) => {
        this.selectedMembers = response.filter(eachMember => eachMember.PRPR_ID == providerId);
        this.selectedMembers.forEach((eacheMember) => {
          // this.epahafService.getListOfFileNetDocuments([{'key':'MemberID',value:eacheMember.memberHmoID},{key:'documentType',value:'Care_Plan'}],'CASPER_MEMBER_DOC','PP').subscribe((data)=>{
          //   console.log(data)
          // })
        })
        this.showSpinner = false;






      },
      (err) => {
        this.showSpinner = false;

      }
    );
  }




  ngOnDestroy(): void {

  }

}